export const AUDIT_STATUS_LABELS = {
  PENDING: '待审核',
  AI_REVIEWING: 'AI 审核中',
  MANUAL_REVIEW: '待人工审批',
  APPROVED: '已通过',
  REJECTED: '已打回',
};

export const DRAFT_STATUS_LABELS = {
  PREPROCESSED: '已预处理',
  PUBLISHED: '已发布',
  MERGED: '已合并',
  SKIPPED: '已跳过',
};

export const TASK_STATUS_LABELS = {
  PUBLISHED: '已发布',
  IN_PROGRESS: '进行中',
  DONE: '已完成',
};

export const VERIFY_STATUS_LABELS = {
  PASS: '通过',
  PARTIAL: '部分通过',
  FAIL: '未通过',
};

export const AI_JOB_STATUS_LABELS = {
  QUEUED: '排队中',
  RUNNING: '执行中',
  SUCCESS: '成功',
  FAILED: '失败',
};

export const AI_JOB_TYPE_LABELS = {
  PREPROCESS: '预处理',
  VERIFY: '验收',
  DEDUPE: '去重',
  REPORT_AI_AUDIT: '日报AI审核',
};

export function formatAuditStatus(status) {
  if (!status) return '-';
  return AUDIT_STATUS_LABELS[status] || status;
}

export function formatDraftStatus(status) {
  if (!status) return '-';
  return DRAFT_STATUS_LABELS[status] || status;
}

export function formatTaskStatus(status) {
  if (!status) return '-';
  return TASK_STATUS_LABELS[status] || status;
}

export function formatVerifyStatus(status) {
  if (!status) return '-';
  return VERIFY_STATUS_LABELS[status] || status;
}

export function formatAiJobStatus(status) {
  if (!status) return '-';
  return AI_JOB_STATUS_LABELS[status] || status;
}

export function formatAiJobType(type) {
  if (!type) return '-';
  return AI_JOB_TYPE_LABELS[type] || type;
}
